import { render, staticRenderFns } from "./EditVendorDid.vue?vue&type=template&id=f5454606&scoped=true&"
import script from "./EditVendorDid.vue?vue&type=script&lang=js&"
export * from "./EditVendorDid.vue?vue&type=script&lang=js&"
import style0 from "./EditVendorDid.vue?vue&type=style&index=0&id=f5454606&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5454606",
  null
  
)

component.options.__file = "EditVendorDid.vue"
export default component.exports